import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

interface ITestDerinCRM_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITestDerinCRM_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetDerinCrmApiToken: any;
  GetDerinCrmApiToken_dummy: any;
  GetGiftCards: any;
  GetGiftCards_dummy: any;
  VerifyCustomerWithSms: any;
  VerifyCustomerWithSms_dummy: any;
  SendGiftCardSms: any;
  SendGiftCardSms_dummy: any;
  isComp322189Visible: "visible" | "hidden";
  isComp983066Visible: "visible" | "hidden";
}

export class TestDerinCRM_ScreenBase extends React.PureComponent<ITestDerinCRM_ScreenProps, any> {
  testderincrm_308177_value_kuikaTableRef: React.RefObject<any>;
  testderincrm_902642_value_kuikaTableRef: React.RefObject<any>;
  testderincrm_969470_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "17674926-0bc7-4f1a-91e6-cf803751ca13",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: []
    },
    {
      Id: "e15eddeb-fa09-4a75-9e86-df0547622907",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 680383, PropertyName: "label", Value: "gettoken" },
        { Id: 897568, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 674724, PropertyName: "label", Value: "get Gift Cards" },
        { Id: 116566, PropertyName: "label", Value: "Send SMS Verification Code" },
        { Id: 727815, PropertyName: "label", Value: "Send gifted card SMS" },
        { Id: 464479, PropertyName: "title", Value: "Cus Card Number" },
        { Id: 273530, PropertyName: "value", Value: "[datafield:customercardnumber]" },
        { Id: 845825, PropertyName: "title", Value: "Id" },
        { Id: 235038, PropertyName: "value", Value: "[datafield:id]" },
        { Id: 305855, PropertyName: "title", Value: "Code" },
        { Id: 894894, PropertyName: "value", Value: "[datafield:code]" },
        { Id: 474392, PropertyName: "title", Value: "Status" },
        { Id: 530217, PropertyName: "value", Value: "[datafield:status]" },
        { Id: 466729, PropertyName: "title", Value: "Created At" },
        { Id: 418239, PropertyName: "value", Value: "[datafield:createdattext]" },
        { Id: 962915, PropertyName: "title", Value: "Valid Through" },
        { Id: 862125, PropertyName: "value", Value: "[datafield:validthroughtext]" },
        { Id: 220895, PropertyName: "title", Value: "Amount" },
        { Id: 626453, PropertyName: "value", Value: "[datafield:amount]" },
        { Id: 623642, PropertyName: "title", Value: "Cus Card Number" },
        { Id: 612007, PropertyName: "value", Value: "[datafield:customercardnumber]" },
        { Id: 955989, PropertyName: "title", Value: "Id" },
        { Id: 367551, PropertyName: "value", Value: "[datafield:id]" },
        { Id: 645536, PropertyName: "title", Value: "Code" },
        { Id: 354140, PropertyName: "value", Value: "[datafield:code]" },
        { Id: 520510, PropertyName: "title", Value: "Status" },
        { Id: 670096, PropertyName: "value", Value: "[datafield:status]" },
        { Id: 445893, PropertyName: "title", Value: "Title" },
        { Id: 570053, PropertyName: "value", Value: "[datafield:createdattext]" },
        { Id: 864163, PropertyName: "title", Value: "Title" },
        { Id: 657109, PropertyName: "value", Value: "[datafield:validthroughtext]" },
        { Id: 301283, PropertyName: "title", Value: "Amount" },
        { Id: 180170, PropertyName: "value", Value: "[datafield:amount]" },
        { Id: 511885, PropertyName: "title", Value: "Cus Card Number" },
        { Id: 973591, PropertyName: "value", Value: "[datafield:cus_sendername]" },
        { Id: 260865, PropertyName: "value", Value: "[datafield:cus_cuscardnumber]" },
        { Id: 779459, PropertyName: "title", Value: "Id" },
        { Id: 765369, PropertyName: "value", Value: "[datafield:cus_id]" },
        { Id: 103566, PropertyName: "title", Value: "Code" },
        { Id: 422323, PropertyName: "value", Value: "[datafield:cus_giftcardcode]" },
        { Id: 363151, PropertyName: "title", Value: "Valid through" },
        { Id: 303236, PropertyName: "value", Value: "[datafield:cus_giftcardvalidthrough]" },
        { Id: 652217, PropertyName: "title", Value: "Receiver name phone msg" },
        { Id: 639669, PropertyName: "value", Value: "[datafield:cus_receivername]" },
        { Id: 513963, PropertyName: "value", Value: "[datafield:cus_receiverphone]" },
        { Id: 984748, PropertyName: "value", Value: "[datafield:cus_messagetext]" },
        { Id: 867565, PropertyName: "title", Value: "Status/IsProces" },
        { Id: 914144, PropertyName: "value", Value: "[datafield:cus_status]" },
        { Id: 861535, PropertyName: "value", Value: "[datafield:cus_isprocessed]" },
        { Id: 430744, PropertyName: "title", Value: "CreatedAt SmsSendate" },
        { Id: 534206, PropertyName: "value", Value: "[datafield:cus_createdat]" },
        { Id: 692715, PropertyName: "value", Value: "[datafield:cus_smssenddate]" }
      ]
    }
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.testderincrm_308177_value_kuikaTableRef = React.createRef();
    this.testderincrm_902642_value_kuikaTableRef = React.createRef();
    this.testderincrm_969470_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetDerinCrmApiToken: "",
      GetGiftCards: "",
      VerifyCustomerWithSms: "",
      SendGiftCardSms: "",
      isComp322189Visible: "hidden",
      isComp983066Visible: "hidden"
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("testderincrm", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
    }

    KuikaAppManager.calculateAndSetBodyHeight("testderincrm", "");
  }

  componentWillUnmount() {}

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("testderincrm", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
    }
  };

  fillFormInitValues() {
    this.props.form.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form.setFields([
        {
          name: fieldName,
          errors: []
        }
      ]);
    }
  };

  TestDerinCRMComponent_680383_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TestDerinCRM/TestDerinCRMComponent_680383_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetDerinCrmApiToken = result?.data.getDerinCrmApiToken;
    formVars.testderincrm_235947_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetDerinCrmApiToken?.data?.accessToken
    );
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TestDerinCRMComponent_680383_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TestDerinCRMComponent_680383_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    formVars.testderincrm_235947_value = ReactSystemFunctions.toString(
      this,
      this.state.GetDerinCrmApiToken?.data?.accessToken
    );

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TestDerinCRMComponent_674724_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CusCardNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "testderincrm_897568_value", "value", "", "", "")
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TestDerinCRM/TestDerinCRMComponent_674724_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetGiftCards = result?.data.getGiftCards;

    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TestDerinCRMComponent_674724_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TestDerinCRMComponent_674724_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    stateVars.dataSource_308177 = this.state.GetGiftCards.validGiftCards;

    stateVars.dataSource_902642 = this.state.GetGiftCards.inValidGiftCards;

    stateVars.dataSource_969470 = this.state.GetGiftCards.cusGiftedCards;

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TestDerinCRMComponent_116566_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      PhoneNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(this, "testderincrm_897568_value", "value", "", "", "")
        ),
        "string"
      )
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TestDerinCRM/TestDerinCRMComponent_116566_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.VerifyCustomerWithSms = result?.data.verifyCustomerWithSms;
    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TestDerinCRMComponent_727815_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ScheduledProcessId_0: ReactSystemFunctions.convertToTypeByName(null, "number")
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(this, "TestDerinCRM/TestDerinCRMComponent_727815_onClick", localVar);
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SendGiftCardSms = result?.data.sendGiftCardSms;
    formVars.testderincrm_278345_value = ReactSystemFunctions.toString(this, stateVars.SendGiftCardSms?.message);
    this.props.form.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TestDerinCRMComponent_727815_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TestDerinCRMComponent_727815_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find((v) => !v.isValid && v.condition);
      if (invalidValidation) {
        const fieldIdMatch = invalidValidation.formName.match(/\d+/);
        if (fieldIdMatch) {
          const fieldId = fieldIdMatch[0];
          const fieldElement = document.getElementById(fieldId);
          if (fieldElement) {
            fieldElement.scrollIntoView({ behavior: "smooth", block: "center" });
            (fieldElement as HTMLElement).focus();
          }
        }
      }
      return true;
    }

    formVars.testderincrm_278345_value = ReactSystemFunctions.toString(this, this.state.SendGiftCardSms?.message);

    this.props.form.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId) {
    let isErrorOccurred = false;
  }
}
